"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Net", {
  enumerable: true,
  get: function () {
    return _net.default;
  }
});
Object.defineProperty(exports, "Socket", {
  enumerable: true,
  get: function () {
    return _socket.default;
  }
});
Object.defineProperty(exports, "fetcher", {
  enumerable: true,
  get: function () {
    return _fetcher.default;
  }
});
Object.defineProperty(exports, "upload", {
  enumerable: true,
  get: function () {
    return _upload.default;
  }
});
Object.defineProperty(exports, "download", {
  enumerable: true,
  get: function () {
    return _download.default;
  }
});
Object.defineProperty(exports, "jsonp", {
  enumerable: true,
  get: function () {
    return _jsonp.default;
  }
});
Object.defineProperty(exports, "jsLoader", {
  enumerable: true,
  get: function () {
    return _jsloader.default;
  }
});
Object.defineProperty(exports, "isEmpty", {
  enumerable: true,
  get: function () {
    return _util.isEmpty;
  }
});
Object.defineProperty(exports, "serialize", {
  enumerable: true,
  get: function () {
    return _util.serialize;
  }
});
Object.defineProperty(exports, "parseJSON", {
  enumerable: true,
  get: function () {
    return _util.parseJSON;
  }
});
exports.middlewares = void 0;

var _printLogger = _interopRequireDefault(require("./middlewares/print-logger"));

var _delay = _interopRequireDefault(require("./middlewares/delay"));

var _net = _interopRequireDefault(require("./net"));

var _socket = _interopRequireDefault(require("./ability/socket"));

var _fetcher = _interopRequireDefault(require("./ability/fetcher"));

var _upload = _interopRequireDefault(require("./ability/upload"));

var _download = _interopRequireDefault(require("./ability/download"));

var _jsonp = _interopRequireDefault(require("./ability/jsonp"));

var _jsloader = _interopRequireDefault(require("./ability/jsloader"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ds Net Plugin
// @author Pluto <huarse@gmail.com>
// @create 2020/01/06 09:19
const middlewares = {
  printLogger: _printLogger.default,
  delay: _delay.default
};
exports.middlewares = middlewares;